import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface ArchiAppSectionsKeyType {
  singular: LocalesKey;
  plural: LocalesKey;
  create: LocalesKey;
  update: LocalesKey;
  delete: LocalesKey;
  selectSection: LocalesKey;
}

export const archiAppSectionsKeys = keyPathMirror<
  ArchiAppSectionsKeyType,
  string
>(
  {
    singular: null,
    plural: null,
    create: null,
    update: null,
    delete: null,
    selectSection: null
  },
  'models.archiAppSections.'
);
